import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useSeo } from "@/lib/seo";
import { api, fileUrl } from "@/lib/api";
import { IMAGES } from "@/constants/images";
import { Reveal } from "@/components/Reveal";

export default function Gallery() {
  const { t, lang } = useApp();
  useSeo("projects");
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => { api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {}); }, []);
  const tx = (obj) => (obj && (obj[lang] || obj.de)) || "";
  const filtered = filter === "all" ? projects : projects.filter((p) => p.category === filter);
  const cats = ["all", "fenster", "sonnenschutz"];

  return (
    <div className="pt-32 md:pt-40 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <span className="text-sm font-semibold uppercase tracking-widest text-accent2">{t.nav.gallery}</span>
          <h1 className="mt-3 font-display font-black text-5xl md:text-7xl tracking-tighter">{t.gallery.title}</h1>
          <p className="mt-6 max-w-xl text-lg text-slate-600">{t.gallery.sub}</p>
        </Reveal>

        <div className="mt-10 flex gap-2 flex-wrap" data-testid="gallery-filters">
          {cats.map((c) => (
            <button key={c} data-testid={`filter-${c}`} onClick={() => setFilter(c)}
              className={`px-5 py-2.5 text-sm font-semibold border transition-colors ${filter === c ? "bg-brand text-white border-brand" : "border-slate-200 text-slate-600 hover:border-brand"}`}>
              {t.cats[c]}
            </button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div className="mt-16 py-24 border border-dashed border-slate-300 text-center text-slate-500 font-display text-xl">{t.gallery.empty}</div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.08}>
                <Link to={`/projekte/${p.id}`} data-testid={`project-card-${p.id}`}
                  className="group block border border-slate-200 hover:border-brand transition-colors">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={fileUrl(p.cover_image || p.after_image) || IMAGES.facade} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="p-5 flex items-start justify-between">
                    <div>
                      <div className="text-xs uppercase tracking-widest text-accent2">{p.location}</div>
                      <h3 className="mt-1.5 font-display font-bold text-xl">{tx(p.title)}</h3>
                    </div>
                    <ArrowUpRight className="text-slate-300 group-hover:text-accent2 transition-colors shrink-0" />
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
